import { useEffect } from 'react';
import { axiosBuyer } from './axios';
import useRefreshToken from './useRefreshToken';
import { useAuth } from './useAuth';
import { StorageService } from '../helper/storage-service';
const { TOKEN_NAME } = require('../helper/application-conf').default;

const useAxiosBuyer = () => {
  const refresh = useRefreshToken();
  const { auth } = useAuth() as any;

  const storage = new StorageService();
  useEffect(() => {
    const requestIntercept = axiosBuyer.interceptors.request.use(
      (config) => {
        const authToken = JSON.parse(storage.getSession(TOKEN_NAME) as any) || null;
        if (config.headers && !config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${authToken?.accessToken}`;
          config.headers['x-user-context'] = JSON.stringify(auth?.role);
        }
        return config;
      }, (error) => Promise.reject(error)
    );

    const responseIntercept = axiosBuyer.interceptors.response.use(
      (response) => response,
      async (error) => {
        const errorObj = JSON.parse(JSON.stringify(error));
        const prevRequest = error?.config;
        if (errorObj?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refresh();
          prevRequest.headers.Authorization = `Bearer ${newAccessToken.accessToken}`;
          storage.setSession(TOKEN_NAME, JSON.stringify(newAccessToken));
          return axiosBuyer(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosBuyer.interceptors.request.eject(requestIntercept);
      axiosBuyer.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosBuyer;
};

export default useAxiosBuyer;
